"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  h1: {
    paddingBottom: theme.spacing(1),
    position: "relative",
    textAlign: "center",
    textTransform: "uppercase",
    "&::before": {
      background: theme.palette.primary.main,
      bottom: 0,
      content: "''",
      height: 1,
      left: "50%",
      marginLeft: theme.spacing(-4),
      position: "absolute",
      width: theme.spacing(8)
    }
  },
  h7: {
    ...theme.customTypography.h7,
    display: "block",
    paddingBottom: theme.spacing(1),
    position: "relative",
    textAlign: "center",
    textTransform: "uppercase",
    "&::before": {
      background: theme.palette.primary.main,
      bottom: 0,
      content: "''",
      height: 1,
      left: "50%",
      marginLeft: theme.spacing(-4),
      position: "absolute",
      width: theme.spacing(8)
    }
  }
}));
const Headline = props => {
  const {
    text,
    variant
  } = props.data;
  const css = useStyles();
  if (!text) {
    return null;
  }
  const headlineSize = "h" + (variant ? variant + 1 : 1);
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 4
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css[headlineSize],
    variant: variant === 6 ? "h2" : headlineSize,
    color: "primary",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};
var _default = exports.default = Headline;